import { useMemo } from 'react';
import { useEntityCache } from './useEntityCache';
import { listZones } from '../services/zones';

/**
 * Зоны камеры по camera_id — тот же кэш-паттерн, что и у имён камер
 * (useCameraNames), применённый к finding 4: колонка «Область» в
 * ViolationRulesTab получает только zone_id (ViolationRuleManagementResponseV2
 * не отдаёт zone_display_name), поэтому имя зоны дотягивается отдельным
 * запросом на камеру и кэшируется по camera_id, а не по каждому правилу.
 */
const mapZones = (data) => (Array.isArray(data?.items) ? data.items : []);

export const useZonesByCamera = (cameraIds) => {
  const ids = useMemo(
    () => [...new Set((cameraIds || []).filter(Boolean))],
    [cameraIds]
  );

  const { byId } = useEntityCache(ids, listZones, mapZones);

  return { zonesByCamera: byId };
};

export default useZonesByCamera;
